// src/api/supportApi.js
import apiClient from './apiClient';

const supportClient = apiClient('');

const supportApi = {
    /**
     * Получить все тикеты (для админа/саппорта)
     * GET /tickets?status=OPEN
     * @param {string} status - OPEN, IN_PROGRESS, WAITING_USER, WAITING_SUPPORT, CLOSED
     */
    async getTickets(status = null) {
        const params = {};
        if (status) params.status = status;
        const res = await supportClient.get('/tickets', { params });
        return res.data;
    },

    /**
     * Получить тикет по ID с сообщениями
     * GET /tickets/:id
     */
    async getTicketById(id) {
        const res = await supportClient.get(`/tickets/${id}`);
        return res.data;
    },

    /**
     * Отправить сообщение в тикет (от саппорта)
     * POST /tickets/:id/messages
     * @param {number} ticketId
     * @param {string} message
     */
    async sendMessage(ticketId, message) {
        const res = await supportClient.post(`/tickets/${ticketId}/messages`, { message });
        return res.data;
    },

    /**
     * Назначить тикет текущему саппорту
     * PUT /tickets/:id/assign
     */
    async assignTicket(ticketId) {
        const res = await supportClient.put(`/tickets/${ticketId}/assign`);
        return res.data;
    },

    /**
     * Закрыть тикет
     * PUT /tickets/:id/close
     */
    async closeTicket(ticketId) {
        const res = await supportClient.put(`/tickets/${ticketId}/close`);
        return res.data;
    },

    /**
     * Отметить сообщения как прочитанные
     * PUT /tickets/:id/read
     */
    async markAsRead(ticketId) {
        const res = await supportClient.put(`/tickets/${ticketId}/read`);
        return res.data;
    },
};

export default supportApi;
